import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { AMENDS_AUDIENCE_INTERNAL } from "../../project/amends/lib/audience-aware-amends.mjs"

export const downloadAuthoringPDF = api(async function downloadAuthoringPDF({
    projectId,
    scheduleId,
    mode = "side-by-side",
    audience = AMENDS_AUDIENCE_INTERNAL,
}) {
    if (!projectId || !scheduleId || !mode) return null

    return query(
        gql`
            query DownloadAuthoringPDF($projectId: String!, $scheduleId: String!, $mode: String!, $audience: String) {
                downloadAuthoringPDF(projectId: $projectId, scheduleId: $scheduleId, mode: $mode, audience: $audience)
            }
        `,
        { projectId, scheduleId, mode, audience },
        { returns: "downloadAuthoringPDF" }
    )
})
